const setBaseUrl = (defaultBaseUrl, baseUrl) => baseUrl || defaultBaseUrl;
export const removeRepeatingForwardSlashes = (input) => input.replace(/\/{2,}/g, '/');
export const setEndpointUrl = (option) => {
    const baseURL = setBaseUrl(process.env.REACT_APP_BASE_URL, option === null || option === void 0 ? void 0 : option.baseUrl);
    const endpointPrefix = removeRepeatingForwardSlashes(`${option.urlPrefix}/${(option === null || option === void 0 ? void 0 : option.pattern) || 'ez'}/${option.urlSuffix}`);
    return `${baseURL}/${endpointPrefix}`;
};
export const GENERAL_API_ERROR_MESSAGE = 'The system encountered an error. Please refresh your cart and try again later.';
const CART_API_PREFIX = `api/cart/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}`;
const PAYMENT_API_PREFIX = `api/payment/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}`;
const APIM_API_PREFIX = `api/apim/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}`;
const FEE_API_PREFIX = `api/fee/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}`;
const SUBSCRIPTION_API_PREFIX = `api/subscription/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}`;
const USER_API_PREFIX = `api/user/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}`;
const RECEIPT_API_PREFIX = `api/statement/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}`;
const DOCUMENT_API_PREFIX = `api/document/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}`;
const AUTHZ_API_PREFIX = `api/authez/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}`;
const UEN_API_PREFIX = `api/uen/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}`;
const INFO_PRODUCT_API_PREFIX = `api/infoproduct/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}`;
const CODE_MGT_PREFIX = `api/codes/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}`;
const PEOPLE_API_PREFIX = `api/people/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}`;
const ENTITY_MANAGEMENT_PREFIX = `api/entity/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}`;
const FILING_PREFIX = `api/filing/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}`;
const EXTRACT_PREFIX = `api/extract/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}`;
const SCREENING_PREFIX = `api/screeningstatus/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}`;
export const CART_ENDPOINT = {
    // POST /api/cart/v1/ez/products/deliveryDetail
    postProductDeliveryDetails: setEndpointUrl({
        urlPrefix: `${CART_API_PREFIX}`,
        urlSuffix: 'products/deliveryDetail',
    }),
    // POST /api/cart/v1/ez/products/validate
    postCartProductValidate: setEndpointUrl({
        urlPrefix: `${CART_API_PREFIX}`,
        urlSuffix: 'products/validate',
    }),
    // GET /api/cart/v1/ez/products/status
    getCartItemStatus: setEndpointUrl({
        urlPrefix: `${CART_API_PREFIX}`,
        urlSuffix: 'products/status',
    }),
    // PUT /api/cart/v1/ez/products - (DELETE)
    putCartProducts: setEndpointUrl({
        urlPrefix: `${CART_API_PREFIX}`,
        urlSuffix: 'products/deletion',
    }),
    // PUT /api/cart/v1/ez/products/empty - (DELETE)
    putEmptyCart: setEndpointUrl({
        urlPrefix: `${CART_API_PREFIX}`,
        urlSuffix: 'products/empty',
    }),
    // GET /api/cart/v1/ez/products
    getCartItems: setEndpointUrl({
        urlPrefix: `${CART_API_PREFIX}`,
        urlSuffix: 'products',
    }),
    // GET /api/cart/v1/ez/count
    getCartCounts: setEndpointUrl({
        urlPrefix: `${CART_API_PREFIX}`,
        urlSuffix: 'count',
    }),
    // PUT /api/cart/v1/ez/subscriptions/deletion - (DELETE)
    putCartAPI: setEndpointUrl({
        urlPrefix: CART_API_PREFIX,
        urlSuffix: 'subscriptions/deletion',
    }),
    // PUT /api/cart/v1/ez/subscriptions/empty - (DELETE)
    putAPIEmptyCart: setEndpointUrl({
        urlPrefix: CART_API_PREFIX,
        urlSuffix: 'subscriptions/empty',
    }),
    // GET /api/cart/v1/ez/subscriptions
    getAPICartItems: setEndpointUrl({
        urlPrefix: CART_API_PREFIX,
        urlSuffix: 'subscriptions',
    }),
    // PUT /api/cart/v1/ez/subscriptions
    putAPICartItems: (cartItemId) => setEndpointUrl({
        urlPrefix: CART_API_PREFIX,
        urlSuffix: `subscription/${cartItemId}`,
    }),
    // POST /api/cart/v1/ez/subscriptions/deliveryDetail
    postAPIDeliveryDetails: setEndpointUrl({
        urlPrefix: CART_API_PREFIX,
        urlSuffix: 'subscriptions/deliveryDetail',
    }),
    // GET /api/cart/v1/ez/subscriptions/status
    getAPICartItemStatus: setEndpointUrl({
        urlPrefix: CART_API_PREFIX,
        urlSuffix: 'subscriptions/status',
    }),
    // POST /api/cart/v1/ez/subscriptions/validate
    postCartAPIValidate: setEndpointUrl({
        urlPrefix: CART_API_PREFIX,
        urlSuffix: 'subscriptions/validate',
    }),
    // PUT /api/v1/cart/products
    // Endpoint for merge guest cart when user login into an user.
    putMergeGuestCart: setEndpointUrl({
        urlPrefix: CART_API_PREFIX,
        urlSuffix: 'products',
    }),
    // PUT /api/cart/v1/ez/subscriptions/empty - (DELETE)
    putProductsEmptyCart: setEndpointUrl({
        urlPrefix: CART_API_PREFIX,
        urlSuffix: 'products/empty',
    }),
    // POST /api/v1/cart/subscription
    postAddToCart: setEndpointUrl({
        urlPrefix: CART_API_PREFIX,
        urlSuffix: 'subscription',
    }),
    // POST /api/v1/cart/product
    postAddProductToCart: setEndpointUrl({
        urlPrefix: `${CART_API_PREFIX}`,
        urlSuffix: 'product',
    }),
};
export const PAYMENT_ENDPOINTS = {
    // POST /api/payment/v1/ez/instruction
    // get payment instructions to proceed with the payment
    postCartInstruction: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: 'instruction',
    }),
    // api/payment/v1/internal/instruction
    postInternalCartInstruction: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: 'instruction',
        pattern: 'internal',
    }),
    // POST /api/payment/v1/ez/status
    postPaymentStatus: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: 'status',
    }),
    // POST /api/payment/v1/ez/instruction/cancel
    postPaymentCancel: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: 'instruction/cancel',
    }),
    // POST /api/payment/v1/ez/initiate
    postInitiatePayment: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: 'initiate',
    }),
    // GET /api/payment/v1/ez/cards
    getCustomerCards: (paymentGatewayType) => setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: `cards?gateway=${paymentGatewayType}`,
    }),
    // POST /api/payment/v1/ez/customerIdentifier
    // add payment methods (cards, visa, master etc.)
    postCustomerIdentifier: (paymentGatewayType) => setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: `customerIdentifier?gateway=${paymentGatewayType}`,
    }),
    // POST /api/payment/v1/ez/confirmCard
    // Endpoint for confirm card.
    postConfirmCard: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: 'confirmCard',
    }),
    // POST api/v1/deleteCard
    PostDeletePaymentCard: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: 'deleteCard',
    }),
    // PUT /api/payment/v1/ez/instruction
    // get payment instructions to proceed with the payment
    putCartInstruction: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: 'instruction/',
    }),
    // GET /api/payment/v1/ez/instruction
    // get payment instructions to proceed with the payment
    getPaymentInstruction: (arn) => setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: `instruction/${arn}`,
    }),
    // GET /api/payment/v1/ez/external/instruction
    // get payment instructions to proceed with the external payment
    postExternalPaymentInstruction: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: `external/instruction`,
    }),
    // GET /api/payment/v1/ez/paymentModes/{ARN}
    getPaymentMethods: (arn) => setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: `paymentModes/${arn}`,
    }),
    // GET /api/payment/v1/ez/external/paymentModes
    postExternalPaymentMethods: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: `external/paymentModes`,
    }),
    // GET /v1/ez/payments
    getPayments: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: 'payments',
    }),
    // GET /v1/ez/payments/:receiptNo
    getPaymentItem: (arn, receiptNo) => {
        const urlSuffix = arn
            ? `payments/receipt?arn=${arn}`
            : `payments/receipt?receiptNo=${receiptNo}`;
        return setEndpointUrl({
            urlPrefix: PAYMENT_API_PREFIX,
            urlSuffix,
        });
    },
    // PUT
    // update default card
    putUpdateDefaultCard: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: 'cards/',
    }),
    // GET /api/payment/v1/ez/configurations/payments
    getPaymentConfigurations: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: 'configurations/payments',
    }),
    // GET /api/payment/v1/ez/payments/download
    downloadPaymentHistory: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: 'payments/download',
    }),
    getSearchRefund: (email, searchValue) => setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: `payment?email=${email}&searchValue=${searchValue}`,
    }),
    postCreateRefundRequest: setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: '/refund/request',
    }),
    getDownloadRefundDoc: (documentUuid) => setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: `refund/download/${documentUuid}`,
    }),
    getRefundDetails: (arn) => setEndpointUrl({
        urlPrefix: PAYMENT_API_PREFIX,
        urlSuffix: `payments/refunds/${arn}`,
    }),
};
export const APIM_ENDPOINTS = {
    // GET /api/apim/v1/ez/categories
    // categoryGroup = Data | Transactional
    getApiCategories: setEndpointUrl({
        urlPrefix: APIM_API_PREFIX,
        urlSuffix: 'categories?categoryGroup',
    }),
    // GET /api/apim/v1/ez/categories/00000000-0000-3600-0000-000000000000
    getApiCategory: setEndpointUrl({
        urlPrefix: APIM_API_PREFIX,
        urlSuffix: 'categories/',
    }),
    // GET /api/apim/v1/ez/categories/{categoryId}/packages
    getApiCategoryPackages: (categoryId) => setEndpointUrl({
        urlPrefix: APIM_API_PREFIX,
        urlSuffix: `categories/${categoryId}/packages`,
    }),
    // GET /api/apim/v1/ez/categories/{categoryId}/apis
    getApiCategoryApis: (categoryId) => setEndpointUrl({
        urlPrefix: APIM_API_PREFIX,
        urlSuffix: `categories/${categoryId}/apis`,
    }),
    // GET /api/apim/v1/ez/categories/{categoryId}/apis/{apiId}
    getApiSummaryDetails: (categoryId, apiId) => setEndpointUrl({
        urlPrefix: APIM_API_PREFIX,
        urlSuffix: `categories/${categoryId}/apis/${apiId}?specs=true`,
    }),
    // GET /api/apim/v1/ez/apis/search?query=Query
    getSearchApis: setEndpointUrl({
        urlPrefix: APIM_API_PREFIX,
        urlSuffix: 'apis/search?query=',
    }),
};
export const FEE_ENDPOINTS = {
    // POST /api/fee/v1/ez/fees
    postFeeValues: setEndpointUrl({
        urlPrefix: FEE_API_PREFIX,
        urlSuffix: 'fees',
    }),
};
export const USER_ENDPOINTS = {
    getUserName: (userId) => setEndpointUrl({
        urlPrefix: USER_API_PREFIX,
        urlSuffix: `profile?userProfileId=${userId}`,
    }),
};
export const SUBSCRIPTION_ENDPOINTS = {
    // GET /api/subscription/v1/ez/account
    getAccountDetails: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'account',
    }),
    // GET /api/v1/ez/account/search/configurations
    getAccountConfigurations: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'account/search/configurations',
    }),
    // GET /api/subscription/v1/ez/account/subscriptions
    getAccountSubscriptions: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'account/subscriptions',
    }),
    // GET /api/subscription/v1/ez/account/subscriptions/inactivity-status
    getAccountInactivityStatus: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'account/subscriptions/inactivity-status',
    }),
    // POST /subscription/v2/ez/trustbar/user/subscription
    postSubscriptionTrustbar: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'trustbar/user/subscription',
    }),
    // POST /subscriptions/reminder
    postSubscriptionReminder: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'subscriptions/reminder',
    }),
    // GET /api/subscription/v1/ez/account/categoryID
    getCategoryAccounts: (categoryId) => setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: `account/subscriptions/${categoryId}`,
    }),
    // put /api/subscription/v1/ez/subscription/{categoryId}/autoTopUp
    putAutoTopupDetails: (categoryId) => setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: `${categoryId}/autoTopUp`,
    }),
    // GET /api/subscription/v1/ez/apps
    getApps: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'apps?',
    }),
    // GET /api/subscription/v1/ez/account/apps
    getAccountApps: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'account/apps?',
    }),
    // POST /api/subscription/v1/ez/account/apps
    postAccountApp: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'account/apps',
    }),
    // setEndpointUrl({ urlPrefix: SUBSCRIPTION_API_PREFIX, urlSuffix: 'account/apps' }),
    // PUT /api/subscription/v1/ez/account
    putAccountDetails: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'account',
    }),
    // PUT /account/apps/{appId}/delete
    putDeleteApp: (appId) => setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: `account/apps/${appId}/delete`,
    }),
    // POST /api/subscription/v1/ez/account
    postAccountDetails: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'account',
    }),
    // POST /v1/ez/account/subscriptions/validate
    postSubscriptionValidation: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'account/subscriptions/validate',
    }),
    // GET - /api/subscription/v1/ez/account/usage/configuration
    getUsageConfigurations: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'account/usage/configuration',
    }),
    // GET - /api/subscription/v1/ez/account/usage/request
    getUsageRequest: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'account/usage/request?usageId=',
    }),
    // GET - /api/subscription/v1/ez/account/usage
    getUsageList: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'account/usage',
    }),
    // POST - /api/subscription/v1/ez/account/usage/download/{pdf : xlsx}
    getUsageDownload: setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: 'account/usage/download',
    }),
    // PUT /account/apps/{appId}/credentials
    putAccountCredentials: (appId) => setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: `account/apps/${appId}/credentials`,
    }),
    // PUT /account/apps/{appId}
    putEditApp: (appId) => setEndpointUrl({
        urlPrefix: SUBSCRIPTION_API_PREFIX,
        urlSuffix: `account/apps/${appId}`,
    }),
};
export const RECEIPT_ENDPOINTS = {
    // GET /api/receipt/v1/ez/status
    getReceiptStatus: setEndpointUrl({
        urlPrefix: RECEIPT_API_PREFIX,
        urlSuffix: 'receipt/status',
    }),
    // GET api/statement/v1/ez/receipt/download
    getReceiptDownload: (documentUuid) => setEndpointUrl({
        urlPrefix: RECEIPT_API_PREFIX,
        urlSuffix: `receipt/download/${documentUuid}`,
    }),
};
export const DOCUMENT_ENDPOINTS = {
    // POST /api/document/v1/ez/download/prepareEzDocument
    postInternetDocument: setEndpointUrl({
        urlPrefix: DOCUMENT_API_PREFIX,
        urlSuffix: 'download/prepareEzDocument',
    }),
};
export const AUTH_ENDPOINTS = {
    // GET /api/authez/v1/ez/kickoff?loginType=Individual|Business
    getRedirectUrl: (type) => setEndpointUrl({
        urlPrefix: AUTHZ_API_PREFIX,
        urlSuffix: `/kickoff?loginType=${type}`,
    }),
    // POST /api/authez/v1/ez/token/regenerate
    postInternetDocument: setEndpointUrl({
        urlPrefix: AUTHZ_API_PREFIX,
        urlSuffix: 'token/regenerate',
    }),
    // GET /api/authez/v1/ez/session/info
    getCurrentAuthInfo: setEndpointUrl({
        urlPrefix: AUTHZ_API_PREFIX,
        urlSuffix: 'session/info',
    }),
    // GET /api/authez/qe/v2/ez/session
    getAuthSession: setEndpointUrl({
        urlPrefix: AUTHZ_API_PREFIX,
        urlSuffix: 'session',
    }),
};
export const FEDERATED_SEARCH_ENDPOINT = {
    getIndustryKeywordSelection: 'https://demo2265468.mockable.io/getIndustryKeywordSelection',
    getIndustryCheckboxSelection: 'https://demo2265468.mockable.io/getIndustryCheckboxSelection',
    getMatchTypeSelectionData: 'https://run.mocky.io/v3/28ee8ee3-692c-4c57-bdea-f5b8003dfef4',
    getEntityTypeSelectionData: 'https://demo2265468.mockable.io/getEntityTypeSelectionData',
    getIssuanceAgenciesSelectionData: 'https://demo2265468.mockable.io/getIssuanceAgenciesSelectionData',
    postEntitiesSearch: 'http://localhost:5000/api/v1/entities',
    // postReservedNamesSearch:
    //   'https://run.mocky.io/v3/7ee7e9fb-7345-4d6e-9379-020e69bdb9d3',
    postReservedNamesSearch0Results: 'https://run.mocky.io/v3/aec176c0-b2bc-42cf-8581-928b6dc20f11',
    postReservedNamesSearch250Results: 'https://run.mocky.io/v3/c346f573-2922-4441-af31-c58e1ae8d37c',
    getPublicAccountStatus: 'https://run.mocky.io/v3/c6e29fe5-0420-489c-9eb2-fc36b5642e01',
    getPeopleSearch: 'https://run.mocky.io/v3/375685e4-6f72-4049-80fe-e0e81c3202fd',
    getPersonCartChoices: 'http://localhost:3001/profile',
    getFees: 'http://localhost:5000/api/v1/fees',
    postAddToCart: 'http://localhost:5000/api/v1/product',
    // getEntityProfileInfo: "http://localhost:5000/api/v1/entity-profile-info",
    getEntityProfileInfo: 
    // "https://run.mocky.io/v3/11dc8fd0-c453-4b92-8855-3f18bfd6e9da",
    'http://localhost:7000/api/v1/ez/products/businessProfientity-profile-info',
};
export const ENTITY_DETAILS_ENDPOINT = {
    // GET api/uen/v1/iz/entity
    getEntityDetails: setEndpointUrl({
        urlPrefix: UEN_API_PREFIX,
        pattern: 'ez',
        urlSuffix: 'entity',
    }),
};
export const INFO_PRODUCT_ENDPOINTS = {
    // POST /api/infoProduct/2.2/v1/ez/people
    postPeople: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'people',
    }),
    // GET /api/infoProduct/2.2/v1/ex/products/peopleProfile/{uuid}
    getPeopleProfile: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'peopleProfile',
    }),
    // POST /api/infoProduct/2.2/v1/ez/product/authentication
    postAuthentication: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'product/authentication',
    }),
    // GET /api/infoProduct/2.2/v1/ez/configurations/search
    getConfigurationsSearch: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'configurations/search',
    }),
    // POST /api/infoProduct/2.2/v1/ez/reservedNames
    postReservedNamesSearch: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'reservedNames',
    }),
    // get /api/infoProduct/2.2/v1/ez/purchase
    getProductDataByCode: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'purchase',
    }),
    // post /api/infoProduct/2.2/v1/ez/download
    postProductDownload: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'download',
    }),
    // get /api/infoProduct/2.2/v1/ez/status/code
    getProductDataStatus: (code, deliveryEmail) => setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: `status/${code}/${deliveryEmail}`,
    }),
    // POST /api/infoProduct/2.2/v1/ez/products/validate
    postProductsValidate: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'products/validate',
    }),
    getMatchTypeOptions: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'configurations/entities',
    }),
    postSearchEntities: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'entities',
    }),
    // GET /api/infoProduct/2.2/v1/ez/products/businessProfile
    getBusinessProfile: (type, uen) => setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: `products/businessProfile/${type}?uen=${uen}`,
    }),
    // GET /api/infoProduct/2.2/v1/ez/products/certificates
    getCertificate: (uen) => setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: `products/certificates/${uen}`,
    }),
    // GET /api/infoProduct/2.2/v1/ez/products/registers
    getRegisters: (uen) => setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: `products/registers/${uen}`,
    }),
    // POST /api/infoProduct/v1/ez/entities/live
    postSearchIndustry: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'entities/live',
    }),
    // GET /api/infoProduct/2.2/v1/ez/configurations/extractSearch
    getLodgementPeriod: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'configurations/extractSearch',
    }),
    // GET /api/infoProduct/2.2/v1/ez/products/extracts/id/
    getProductExtract: () => setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: `products/extracts`,
    }),
    getFreeProducts: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: `freeProducts`,
    }),
    postFreeProductsDownload: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'freeProducts/download',
    }),
    getFreeProductsStatus: (freeProductIds) => setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: `freeProducts/status?freeProductIds=${freeProductIds}`,
    }),
    getFinancialProfile: (type) => setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: `products/financialProfile/${type}`,
    }),
    getProductAuthentication: (authNo, identifierId) => setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: `product/authentication?authNo=${authNo}&identifierId=${identifierId}`,
    }),
    getDownloadAll: (downloadCode, deliveryEmail) => setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: `downloadAll/${downloadCode}/${deliveryEmail}`,
    }),
    postFreeProductsDownloadSelected: setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: 'freeProducts/download/selected',
    }),
    getEntityRestrictions: (uen) => setEndpointUrl({
        urlPrefix: INFO_PRODUCT_API_PREFIX,
        urlSuffix: `/restrictions/entity/${uen}`,
    }),
};
export const ENTITY_MANAGEMENT_ENDPOINT = {
    getEntityInfo: (uen) => setEndpointUrl({
        urlPrefix: ENTITY_MANAGEMENT_PREFIX,
        urlSuffix: `/entityInfoIps?uen=${uen}`,
    }),
    getPublicEntity: (uen) => setEndpointUrl({
        urlPrefix: ENTITY_MANAGEMENT_PREFIX,
        urlSuffix: `publicAccountingEntity/details?uen=${uen}`,
    }),
    // v1/ez/csp/profileDetails
    getCSP: (uen) => setEndpointUrl({
        urlPrefix: ENTITY_MANAGEMENT_PREFIX,
        urlSuffix: `csp/profileDetails?uen=${uen}`,
    }),
    getChargeCodes: (uen) => setEndpointUrl({
        urlPrefix: ENTITY_MANAGEMENT_PREFIX,
        urlSuffix: `charges/chargeDetails?uen=${uen}`,
    }),
    getPeopleAccountantEntity: (officerProfileId) => setEndpointUrl({
        urlPrefix: ENTITY_MANAGEMENT_PREFIX,
        urlSuffix: `individual/positionAccountantDetails?officerProfileId=${officerProfileId}`,
    }),
    getEntityFormerName: (entityProfileId) => setEndpointUrl({
        urlPrefix: ENTITY_MANAGEMENT_PREFIX,
        urlSuffix: `entityNameHistory?entityProfileId=${entityProfileId}`,
    }),
};
export const CODE_MGT_ENDPOINTS = {
    getPAStatus: setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: 'pa-status?parentcodetables=pa-status&parentCodeValue=pa-status&useCaseCode=INTERNETNO',
    }),
    getSSICCode: (ssicCode) => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `ssic?description=${ssicCode}`,
    }),
    getIssuanceAgency: (issuanceAgency) => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `issuance-agency?value=${issuanceAgency}`,
    }),
    getEntityStatus: (entityStatusCode, isNonACRA) => {
        const urlSuffix = isNonACRA
            ? `uen-entity-status?value=${entityStatusCode}`
            : `entity-status?value=${entityStatusCode}`;
        return setEndpointUrl({
            urlPrefix: CODE_MGT_PREFIX,
            urlSuffix,
        });
    },
    getEntityStatusColor: (entityStatusCode, isNonACRA) => {
        const urlSuffix = isNonACRA
            ? `uen-status?parentCodeTables=uen-entity-status&parentCodeValue=${entityStatusCode}`
            : `uen-status?parentCodeTables=entity-status&parentCodeValue=${entityStatusCode}`;
        return setEndpointUrl({
            urlPrefix: CODE_MGT_PREFIX,
            urlSuffix,
        });
    },
    getIssuanceAgencyOptions: (useCaseCode) => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `issuance-agency?useCaseCode=${useCaseCode}`,
    }),
    getEntityTypeOptions: (parentCodeTables, parentCodeValue, useCaseCode) => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `uen-entity-type?parentCodeTables=${parentCodeTables}&parentCodeValue=${parentCodeValue}&useCaseCode=${useCaseCode}`,
    }),
    getUenEntityStatusOptions: (uenEntityType, parentCodeValue) => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `uen-entity-status?parentCodeTables=${uenEntityType}&parentCodeValue=${parentCodeValue}`,
    }),
    getEntityStatusOptions: (uenEntityType, parentCodeValue) => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `entity-status?parentCodeTables=${uenEntityType}&parentCodeValue=${parentCodeValue}`,
    }),
    getAddress: (postalCode) => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `address?postalCode=${postalCode}`,
    }),
    getNameSuffix: (entityNameSuffix) => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `suffix?value=${entityNameSuffix}`,
    }),
    getEntityType: () => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: 'entity-type-display?useCaseCode=ISHPUINO',
    }),
    getEntityTypeDesc: (value) => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `entity-type-display?value=${value}`,
    }),
    getExtractCategory: () => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: 'extract-category',
    }),
    getAnnotationMsg: (value) => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `annotation-message?value=${value}`,
    }),
    postTransactionDescription: () => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `master/tables`,
    }),
    getRefundCodes: () => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `refund-reason`,
    }),
    getIssuanceAgencyUrl: (issuanceAgency) => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `issuance-agency-url?value=${issuanceAgency}`,
    }),
    getCodeManagement: () => setEndpointUrl({
        urlPrefix: CODE_MGT_PREFIX,
        urlSuffix: `master/tables`,
    }),
};
export const PEOPLE_ENDPOINTS = {
    // GET /api/people/v1/ez/publicAccountant/profileDetailsIps
    getPeoplePublicAccountant: (userProfileId) => setEndpointUrl({
        urlPrefix: PEOPLE_API_PREFIX,
        urlSuffix: `publicAccountant/profileDetailsIps?userProfileId=${userProfileId}`,
    }),
    // GET /api/people/v1/ez/csp/qiProfileIps
    getPeopleQiProfile: (userProfileId) => setEndpointUrl({
        urlPrefix: PEOPLE_API_PREFIX,
        urlSuffix: `csp/qiProfileIps?userProfileId=${userProfileId}`,
    }),
};
export const SUN_ENDPOINTS = {
    getSunList: setEndpointUrl({
        urlPrefix: UEN_API_PREFIX,
        pattern: 'ez',
        urlSuffix: 'suns',
    }),
};
export const FILING_ENDPOINTS = {
    getAnnualFilling: (entityProfileId) => setEndpointUrl({
        urlPrefix: FILING_PREFIX,
        urlSuffix: `annualFiling/history?uen=${entityProfileId}`,
    }),
};
const mockDeploymentEnv = (process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT || '').toLowerCase() === 'local'
    ? 'local'
    : 'dev';
export const MANAGE_REFUND_ENDPOINT = {
    postRefund: `https://d276c3j5hg.execute-api.ap-southeast-1.amazonaws.com/${mockDeploymentEnv}/refund/create-internet`,
    searchRefund: `https://d276c3j5hg.execute-api.ap-southeast-1.amazonaws.com/${mockDeploymentEnv}/refund/search`,
};
export const EXTRACT_ENDPOINTS = {
    getExtractResults: () => setEndpointUrl({
        urlPrefix: EXTRACT_PREFIX,
        urlSuffix: `extracts/ishop`,
    }),
    getExtractRelatedResults: (extractId) => setEndpointUrl({
        urlPrefix: EXTRACT_PREFIX,
        urlSuffix: `extracts/${extractId}/related`,
    }),
};
export const SCREENING_ENDPOINTS = {
    // POST /api/screeningstatus/v1/ez/business/invalidAddress/status
    postAddressScreenStatus: setEndpointUrl({
        urlPrefix: `${SCREENING_PREFIX}`,
        urlSuffix: '/business/invalidAddress/status',
    }),
};
